import React from 'react'

const EmployeeModuleSubcategory: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_3153_50817)"
      fill-opacity="0.1"
    />
    <path
      d="M15.9733 23.9978C14.0299 23.9978 12.1164 23.9978 10.1731 23.9978C9.24621 23.9978 8.91733 23.5792 9.06682 22.7122C9.63489 19.4832 12.4154 17.0614 15.6444 16.9418C19.0528 16.8222 22.0725 19.0646 22.8499 22.2637C23.1788 23.5792 22.8499 23.9978 21.5045 23.9978C19.6508 23.9978 17.827 23.9978 15.9733 23.9978Z"
      fill="#052351"
    />
    <path
      d="M16.0035 8.00232C18.0964 8.00232 19.7707 9.64672 19.7707 11.7097C19.7707 13.7129 18.0067 15.447 15.9736 15.447C13.9405 15.447 12.2363 13.7129 12.2363 11.6798C12.2363 9.61682 13.8807 8.00232 16.0035 8.00232Z"
      fill="#052351"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3153_50817"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0062FF" />
        <stop offset="1" stop-color="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default EmployeeModuleSubcategory
